export const BENEFIT_MIGRATION_PATH = '/beneficios/migracao';
export const BENEFIT_MIGRATION_TRACKING_PATH = '/beneficios/migracao/status';
export const LEGACY_BENEFITS_HISTORY_PATH = '/beneficios/historico-vr';
export function resolveBenefitMigrationPath(entry) {
    switch (entry) {
        case 'acceptance':
            return BENEFIT_MIGRATION_PATH;
        case 'tracking':
            return BENEFIT_MIGRATION_TRACKING_PATH;
        case 'emissor':
            return '/beneficios';
        default:
            return null;
    }
}
